import * as React from "react";
import { EventSourceProvider as GenericEventSourceProvider, useEventSource } from "../../lib/eventing/useEvent";
import { AppEventBus } from "../../services/appEventBus";

/**
 * Provider component to make the event bus available to child components.
 * This is just a typed wrapper around the generic EventSourceProvider.
 */
export const EventBusProvider: React.FC<{
    eventBus: AppEventBus;
    children: React.ReactNode;
}> = ({ eventBus, children }) => {
    return (
        <GenericEventSourceProvider source={eventBus}>
            {children}
        </GenericEventSourceProvider>
    );
};

/**
 * Hook to access the typed event bus instance.
 * 
 * For most use cases, prefer using the generic `useEvent` hook from the eventing library:
 * 
 * @example
 * import { useEvent } from "../../lib/eventing/useEvent";
 * 
 * // Listen to a specific event
 * useEvent(bus => bus.namespaces.app.events.appMounted.on((payload) => {
 *   console.log("Worksheet:", payload.worksheetName);
 * }));
 */
export function useEventBus(): AppEventBus {
    return useEventSource<AppEventBus>();
}
